import { render } from "./tenantControls.vue?vue&type=template&id=30cc65a1&scoped=true&ts=true"
import script from "./tenantControls.vue?vue&type=script&lang=ts"
export * from "./tenantControls.vue?vue&type=script&lang=ts"

import "./tenantControls.vue?vue&type=style&index=0&id=30cc65a1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30cc65a1"]])

export default __exports__